import { useCallback, useContext } from 'react'

import ClientDataComponentContext from './ClientDataComponentContext'
import { ClientDataComponentIdentifier } from './types'

const useClientDataComponentContext = (id: ClientDataComponentIdentifier) => {
  const context = useContext(ClientDataComponentContext)

  if (!context) {
    throw new Error(
      'useClientDataComponentContext must be used within a ClientDataComponentProvider',
    )
  }

  const { getElement, setElement, hiddenFallbackIds, setHiddenFallbackIds } = context

  return {
    element: getElement(id),
    setElement: (element: HTMLElement | null) => setElement(id, element),
    isFallbackShown: !hiddenFallbackIds.includes(id),
    setIsFallbackShown: useCallback(
      () => setHiddenFallbackIds(ids => [...ids, id]),
      [setHiddenFallbackIds, id],
    ),
  }
}

export default useClientDataComponentContext
